import {Component, Input} from '@angular/core';
import {OfferLocationTransport} from "@core/shared/models/offer/offer-location/offer-location-transport";

@Component({
    selector: 'app-core-offer-location-transport-calculation-details',
    templateUrl: './offer-location-transport-calculation-details.component.html',
    styleUrl: './offer-location-transport-calculation-details.component.scss',
    standalone: false
})
export class OfferLocationTransportCalculationDetailsComponent {

    @Input() offerLocationTransport: OfferLocationTransport;

    @Input() displayTransportDuration: boolean;

    protected readonly Math = Math;

    protected readonly parseFloat = parseFloat;

    public formatDuration(seconds: number): string {

        // Arrondi à la minute la plus proche

        let totalMinutes: number = Math.round(seconds / 60);

        // Durée minimale : 1 minute

        if (totalMinutes < 1) {

            totalMinutes = 1;
        }

        const hours: number = Math.floor(totalMinutes / 60);

        const minutes: number = totalMinutes % 60;

        if (hours > 0) {

            return minutes > 0 ? `${hours}h ${minutes}min` : `${hours} h`;

        } else {

            return `${minutes} min`;
        }
    }

    get recommendedTransportLabel(): string {

        switch (this.offerLocationTransport.transport.type){

            case 'train-station':

                return 'transport.trainStation.recommended.short.value';

            case 'airport':

                return 'transport.airport.recommended.short.value';
        }
    }

    get distanceLabel(): string {

        switch (this.offerLocationTransport.transport.type){

            case 'train-station':

                return 'distance.from.trainStation.value';

            case 'airport':

                return 'distance.from.airport.value';
        }
    }
}
